import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchExternalInvoice } from '../query-api'

export const useFetchExternalInvoiceFromBilly = (externalInvoiceId: string) => {
  const { data, error, isFetching, isLoading } = useQuery(
    [QueryKeys.ExternalInvoice, externalInvoiceId],
    () => fetchExternalInvoice(externalInvoiceId),
    {
      enabled: !!externalInvoiceId,
    },
  )

  return { externalInvoice: data?.externalInvoice, error, isFetching, isLoading }
}
